import { render, staticRenderFns } from "./InputGroup.vue?vue&type=template&id=e4872e2e&scoped=true&"
import script from "./InputGroup.vue?vue&type=script&lang=js&"
export * from "./InputGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4872e2e",
  null
  
)

export default component.exports